<template>
  <div class="container-fluid vh-100 h-100 vw-100 m-0 p-0 dkt-reg-bg">
    <nav></nav>
    <div class="container py-5 d-flex align-items-center">
    <div class="row rounded" style="background: url('https://dukakit.com/wp-content/uploads/2025/05/regbg.jpg'); background-size: cover; background-position: center top; border-radius: 20px !important;">
          <div class="col-md-6 no-gutters order-md-1 order-2 box-shadow-0 bg-transparent border-0" style="border-radius: 20px 0 0 20px !important; box-shadow:none">
            <div class="card-body d-flex flex-column justify-content-start">
            <h2 class="h1 text-light pt-3">Focus on What You Do Best</h2>
        <h5 class="text-weight-400 text-center py-3">
            Let Dukakit handle your sales, inventory, finances, and taxes—all in one place. Our
            all-in-one platform empowers solopreneurs to streamline operations.</h5>

           <div id="carouselExampleSlidesOnly" class="carousel slide p-0 m-0" data-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
        <img src="https://dukakit.com/wp-content/uploads/2024/04/WhatsApp-Image-2024-04-19-at-1.09.12-PM.jpeg" class="d-block w-100" alt="dukakit">
    </div>
    <div class="carousel-item">
      <img src="https://dukakit.com/wp-content/uploads/2024/04/WhatsApp-Image-2024-04-19-at-1.09.17-PM.jpeg" class="d-block w-100" alt="dukakit">
    </div>
    <div class="carousel-item">
      <img src="https://dukakit.com/wp-content/uploads/2024/04/WhatsApp-Image-2024-04-19-at-1.09.17-PM-1-uai-720x720.jpeg" class="d-block w-100" alt="dukakit">
    </div>
  </div>
</div>
</div>
</div>

          <div class="col-md-6 no-gutters order-1 order-md-2 bg-transparent border-0" style="border-radius: 0 20px 20px 0 !important; box-shadow:none">
            <div class="card-body text-center">
              <a class="navbar-brand pt-3 me-2" href="/" aria-label="Bootstrap">
                <img
                  src="https://app.dukakit.com/images/DukaKitlogotr.png"
                  style="width: 170px !important; height: auto"
                />
              </a>
              <div class="bg-light border rounded border-danger py-4 px-4" v-if="formErrors.backend">
                <h5 class="text-danger">{{ formErrors.backend  }}</h5>
              </div>

              <form @submit.prevent="freeTrial">
                 <h5 class="text-weight-400 text-center py-1">Sign up today to see how you can improve on your business performance, and learn more about our free trial.
           </h5>

                <div class="form-row py-2">
                  <div class="col-12">
                    <input
                      v-model="register.fullname"
                      type="text"
                      class="form-control border-bottom"
                      placeholder="Full Name"
                    />
                    <small v-if="formErrors.fullName" class="text-danger">{{
                      formErrors.fullName
                    }}</small>
                  </div>
                </div>

                <div class="form-group py-2">
                  <input
                    v-model="register.email"
                    type="email"
                    class="form-control border-bottom"
                    placeholder="Email"
                  />
                  <small v-if="formErrors.email" class="text-danger">{{ formErrors.email }}</small>
                </div>

                <div class="form-group">
                    <vue-tel-input v-on:validate="validatePhoneNumber" v-model="register.phone"></vue-tel-input>

                  <small v-if="register.validPhoneMessage && register.phone" class="text-danger">{{
                    register.validPhoneMessage
                  }}</small>
                </div>

                <div class="form-group py-2">
                  <input
                    v-model="register.company"
                    type="text"
                    class="form-control border-bottom"
                    placeholder="Company name"
                  />
                  <small v-if="formErrors.companyName" class="text-danger">{{
                    formErrors.companyName
                  }}</small>
                </div>

                <div class="form-group py-2">
                  <input
                    v-model="register.businesstype"
                    type="text"
                    class="form-control border-bottom"
                    placeholder="Creative agency, Construction etc"
                  />
                  <small v-if="formErrors.industry" class="text-danger">{{
                    formErrors.industry
                  }}</small>
                </div>

                <div class="form-group py-3">
                  <div class="input-group mb-3">
                    <input
                      :type="passwordVisible ? 'text' : 'password'"
                      v-model="register.password"
                      class="form-control border-bottom"
                      placeholder="Password"
                    />
                    <div class="input-group-append">
                      <span
                        class="btn btn-secondary input-group-text"
                        @click="togglePasswordVisibility"
                      >
                        {{ passwordVisible ? 'Hide' : 'Show' }} Password
                      </span>
                    </div>
                  </div>
                  <small v-if="formErrors.password" class="text-danger">{{
                    formErrors.password
                  }}</small>
                </div>

                <div class="form-group py-1" v-if="!hasAffiliateCode">
                  <input
                    v-model="register.referralCode"
                    type="text"
                    class="form-control border-bottom"
                    placeholder="Enter referral code"
                  />
                  <hr />
                </div>

                <div class="form-group pt-3">
                  <button type="submit" class="btn btn-primary w-100">
                    Register For Free Trial
                  </button>
                  <p class="py-2">
                    Already have an account? <a class="text-primary" href="/login">Login</a>
                  </p>
                </div>
              </form>
            </div>
          </div>

    </div>
  </div>
  </div>
</template>

<script>
    import VueTelInput from 'vue-tel-input';
    export default {
        name: "registerbusiness",
        data() {
            return {
                register: {
                    selling: null,
                    fullname: '',
                    email: '',
                    company: '',
                    phone: '',
                    businesstype: '',
                    validPhoneMessage: '',
                    confirmPassword: '',
                    password: '',
                    referralCode:'',

                },
                hasAffiliateCode:true,
                formErrors:{
                    backend:''
                },
                passwordVisible: false,
                businessoptions: [{
                        value: null,
                        text: 'What does your business provide'
                    },
                    {
                        value: 0,
                        text: 'Service provisioning'
                    },
                    {
                        value: 1,
                        text: 'Selling of items'
                    },
                    {
                        value: 2,
                        text: 'Both Service and Items '
                    },
                ]
            }
        },
        mounted(){
            this.checkRouteIfHasAffilliate()
        },
        methods: {
            validatePassword() {
                    if (this.register.password.length < 8) {

                        this.formErrors.password = 'Password must have at least 8 characters.';
                    } else {
                        this.formErrors.password = null;
                         }
            },
            checkRouteIfHasAffilliate()
            {
                const urlParams = new URLSearchParams(window.location.search);
                if(!urlParams.has('ref'))
                {
                    this.hasAffiliateCode = false
                }
                else
                {
                    this.register.referralCode = urlParams.get('ref')
                }

            },
            togglePasswordVisibility() {
                this.passwordVisible = !this.passwordVisible;
            },
           async freeTrial(e) {
                e.preventDefault();

                if(this.register.fullname === '')
                {
                    this.formErrors.fullName="Enter your name"

                }
                if(this.register.phone === '')
                {
                    this.register.validPhoneMessage = "Enter your phone number"

                }
                if(this.register.email === '')
                {
                    this.formErrors.email="Enter a valid email"

                }
                if(this.register.companyname === '')
                {
                    this.formErrors.companyName="Enter your business name"

                }


                if(this.register.industry === '')
                {
                    this.formErrors.industry="Which industry are you in?"

                }


                if(Object.keys(this.formErrors).length > 0)
                {
                    await axios.post('/api/register-business', {
                    ...this.register
                }).then(results => {
                    if (results.data.message) {
                        // redirect to thank you
                        window.location.href = '/otp-verification?otp-no='+results.data.otpno
                    }
                }).catch(error => {
                    console.log(error.response.data)
                    this.formErrors.backend = error.response.data.message
                })
                }



            },
            validatePhoneNumber(phoneNumber) {
               this.register.validPhoneMessage = (phoneNumber.valid) ? '' : "Enter a valid phone number"
            },
        },
        watch: {
          'register.password':function(before, after){
            this.validatePassword()
          }
        },
    }
</script>

<style scoped>

</style>
